export function is(val: unknown, type: string) {
    return toString.call(val) === `[object ${type}]`;
}

export function isObject(val: any): val is Record<any, any> {
    return val !== null && is(val, "Object");
}

export function deepMerge<T = any>(src: any = {}, target: any = {}): T {
    let key: string;
    for (key in target) {
        src[key] = isObject(src[key])
            ? deepMerge(src[key], target[key])
            : (src[key] = target[key]);
    }
    return src;
}
